//
// Server.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../TransportModel";
import "../media/ServerConfig";
import "../media/CadenceVersion";
import "@sas-dvr/ltjs-commons/resources/network/URL";

var Server = createModule("transport::Server", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        hostName: 7,
        versionId: 4,
        scheme: 7,
        cadenceVersion: 1,
        versionString: 7,
        port: 4,
        meta: 1,
        useSSL: 2,
    },
    ,
    ,
    {
        getBaseURL: [1],
    },
    {
        _create: [4],
    },
    ,
]);
export default Server;
